import { Switch, Route, Redirect } from 'react-router'

import { WarehousePageSection, defaultSection } from './WarehousePageSection'

export const WarehousePage = ({ baseUrl }: { baseUrl: string }) => {
  return (
    <Switch>
      <Route
        path={`${baseUrl}/:section`}
        component={() => <WarehousePageSection baseUrl={baseUrl} />}
      />
      <Redirect from={baseUrl} to={`${baseUrl}/${defaultSection}`} exact />
    </Switch>
  )
}
